"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Separator } from "@/components/ui/separator";
import { Instagram, Send } from "lucide-react";
function NewsletterForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div data-section-id="1646" className="rounded-sm border border-primary/10 bg-primary/5 p-4">
        <p className="text-sm font-serif italic text-primary">{successMessage}</p>
        <Button onClick={resetForm} variant="ghost" size="sm" className="mt-3 w-full font-sans tracking-tight">
          Subscribe Again
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="space-y-4">
        <FormField control={control} name="first_name" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-xs uppercase tracking-widest font-sans text-muted-foreground">Full Name</FormLabel>
              <FormControl>
                <Input type="text" placeholder="Joan Didion" className="bg-transparent border-0 border-b border-border rounded-none focus-visible:ring-0 focus-visible:border-primary px-0" {...field} />
              </FormControl>
              <FormDescription className="text-xs font-sans italic">Optional – so I can address you properly</FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email address"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-xs uppercase tracking-widest font-sans text-muted-foreground">Email Address *</FormLabel>
              <FormControl>
                <Input type="email" placeholder="hello@kaleighwrites.com" className="bg-transparent border-0 border-b border-border rounded-none focus-visible:ring-0 focus-visible:border-primary px-0" {...field} />
              </FormControl>
              <FormDescription className="text-xs font-sans italic">Monthly insights on clarity and conversion.</FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="consent" rules={{
        required: "Agreement is required to proceed"
      }} render={({
        field
      }) => <FormItem className="flex flex-row items-start space-x-3 space-y-0">
              <FormControl>
                <Checkbox checked={field.value} onCheckedChange={field.onChange} className="mt-1 rounded-none border-primary" />
              </FormControl>
              <div className="space-y-1 leading-none">
                <FormLabel className="text-xs font-sans font-normal">
                  I agree to receive the strategy newsletter from KaleighWrites
                </FormLabel>
                <FormDescription className="text-xs font-sans">Unsubscribe with a single click anytime.</FormDescription>
                <FormMessage />
              </div>
            </FormItem>} />

        {submitError && <div className="rounded-sm border border-destructive/20 bg-destructive/5 p-3">
            <p className="text-xs font-sans text-destructive">{submitError}</p>
          </div>}

        <Button type="submit" disabled={isSubmitting} className="w-full rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 transition-all" size="lg">
          {isSubmitting ? <>
              <Send className="animate-pulse size-4" />
              Processing...
            </> : <>
              <Send className="size-4" />
              Join the Archive
            </>}
        </Button>
      </div>
    </Form>;
}
export default function GlamVaultUniversalFooter() {
  return <section id="footer" className="bg-background text-foreground py-16 px-4 border-t border-primary/10">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {}
          <div className="space-y-6">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569965/img/kaleighwrites_logo.png" alt="KaleighWrites" className="h-8" />
            <p className="text-sm font-serif text-muted-foreground leading-relaxed">
              Boutique copywriting and content strategy for small businesses, translating complex tech and ecommerce concepts into clear, actionable messaging.
            </p>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-xs uppercase tracking-widest font-sans font-bold text-primary">Navigation</h3>
            <nav className="flex flex-col space-y-3">
              <Link to="/HomePage" className="text-sm font-sans text-foreground/80 hover:text-primary transition-colors border-b border-transparent hover:border-primary w-fit">
                Home
              </Link>
              <Link to="/AboutKaleighPage" className="text-sm font-sans text-foreground/80 hover:text-primary transition-colors border-b border-transparent hover:border-primary w-fit">
                About Kaleigh
              </Link>
              <Link to="/TheContentArchivePage" className="text-sm font-sans text-foreground/80 hover:text-primary transition-colors border-b border-transparent hover:border-primary w-fit">
                The Content Archive
              </Link>
              <Link to="#" className="text-sm font-sans text-foreground/80 hover:text-primary transition-colors border-b border-transparent hover:border-primary w-fit">
                Strategy Services
              </Link>
              <Link to="#" className="text-sm font-sans text-foreground/80 hover:text-primary transition-colors border-b border-transparent hover:border-primary w-fit">
                Contact
              </Link>
            </nav>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-xs uppercase tracking-widest font-sans font-bold text-primary">Connect</h3>
            <div className="flex flex-col space-y-4">
              <Link to="https://instagram.com/kaleighwrites" newTab className="flex items-center gap-3 text-sm font-sans text-foreground/80 hover:text-primary transition-colors group">
                <Instagram className="size-5 group-hover:scale-110 transition-transform text-primary" />
                <span>Instagram</span>
              </Link>
              <Link to="https://linkedin.com/in/kaleighwrites" newTab className="flex items-center gap-3 text-sm font-sans text-foreground/80 hover:text-primary transition-colors group">
                <svg className="size-5 group-hover:scale-110 transition-transform text-primary" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
                <span>LinkedIn</span>
              </Link>
              <Link to="https://twitter.com/kaleighwrites" newTab className="flex items-center gap-3 text-sm font-sans text-foreground/80 hover:text-primary transition-colors group">
                <svg className="size-5 group-hover:scale-110 transition-transform text-primary" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.84 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                </svg>
                <span>Twitter</span>
              </Link>
            </div>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-xs uppercase tracking-widest font-sans font-bold text-primary">The Strategy Edit</h3>
            <FormProvider formId="kaleighwrites_newsletter" sectionName="footer" defaultValues={{
            first_name: "",
            email: "",
            consent: false
          }} submitText="Join the Archive" successMessage="Welcome to the archive. Your first strategy guide is on its way." errorMessage="An error occurred. Please try again or reach out directly.">
              <NewsletterForm />
            </FormProvider>
          </div>
        </div>

        <Separator className="my-8 bg-border/40" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs font-sans text-muted-foreground tracking-tight">
          <p>&copy; 2024 KaleighWrites Studio. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Separator orientation="vertical" className="h-4 bg-border/40" />
            <Link to="#" className="hover:text-primary transition-colors">
              Terms of Engagement
            </Link>
            <Separator orientation="vertical" className="h-4 bg-border/40" />
            <Link to="#" className="hover:text-primary transition-colors">
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </section>;
}